"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonType = void 0;
var PersonType;
(function (PersonType) {
    PersonType["Executive"] = "executive";
    PersonType["BoardMember"] = "boardMember";
})(PersonType || (exports.PersonType = PersonType = {}));
